// Admin-authored content (banner copy today) is stored per language in a
// sidecar table, keyed by the short code the apps keep in
// UserProfile.preferredLanguage ('en', 'id') rather than the full locale tag
// the admin UI uses ('en-US', 'id-ID').

import { locales } from '../config';
import { formatLocale } from './formatLocale';

export function toLanguageCode(locale) {
  return String(locale || '').split('-')[0].toLowerCase();
}

// Default locale is the first entry in config.locales; its copy lives on the
// parent row itself, not in the translations table.
export const DEFAULT_LANGUAGE = toLanguageCode(locales[0]);

// Drives the language tabs, so enabling a locale in config is all it takes to
// get a new tab. Default first, deduped by short code.
export const CONTENT_LANGUAGES = locales.reduce((acc, locale) => {
  const code = toLanguageCode(locale);
  if (!code || acc.some(entry => entry.code === code)) return acc;
  acc.push({ code, locale, label: formatLocale(locale) });
  return acc;
}, []);

export const LANGUAGE_CODES = CONTENT_LANGUAGES.map(entry => entry.code);

// Languages that need a translation row. The default one is excluded because
// its copy is the parent row.
export const TRANSLATABLE_LANGUAGES = CONTENT_LANGUAGES.filter(
  entry => entry.code !== DEFAULT_LANGUAGE
);
